import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import AirConditioningSystemEnum from '../../../assets/js/AirConditioningSystemEnum';
import ApplicationFlowEnum from '../../../assets/js/ApplicationFlowEnum';
import Button from '../../../components/UI/Button/CustomButton';
import {
  changePage,
  changeSoftPullValue,
  resetNewAppState,
  resetState,
  setFlow,
  submitMindfire,
} from '../../../redux/actions/index';

const ScoreError = props => {
  const {
    dispatchSetFlow,
    children,
    history,
    airConditioningSystem,
    email,
    dealerUserId,
    did,
    dispatchSubmitMindfire,
  } = props;

  const mindFireRequest = {
    email: email,
    lastPage: '12006',
    dealerUserId: dealerUserId,
    did: did,
  };

  return (
    <Container>
      <Row>
        <Col />
        <Col sm="5">{children}</Col>
        <Col sm="6">
          <p>
            A soft pull of your credit profile was unsuccessful with the information you provided.
            <br />
            <br />
            You can still apply for financing or lease purchase options without prequalification,
            just click one of the buttons below to continue.
          </p>
          <Button
            title="Apply for Financing Option"
            clickHandler={() => {
              dispatchSubmitMindfire(mindFireRequest);
              dispatchSetFlow(ApplicationFlowEnum.FTL_FLOW.value);
              history.push(ApplicationFlowEnum.FTL_FLOW.path);
            }}
          />
          {airConditioningSystem ===
          AirConditioningSystemEnum.AIR_CONDITION_OR_HEATING_SYSTEM.id ? (
            <Button
              title="Apply for Lease Purchase Program"
              clickHandler={() => {
                dispatchSubmitMindfire(mindFireRequest);
                dispatchSetFlow(ApplicationFlowEnum.MICROF_FLOW.value);
                history.push(ApplicationFlowEnum.MICROF_FLOW.path);
              }}
            />
          ) : null}
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = state => ({
  email: state.preQualificationInformation.email,
  dealerUserId: state.auth.dealerUserId,
  did: state.auth.did,
  airConditioningSystem:
    state.preQualificationInformation.airConditioningSystem ||
    (state.softPull.applicationSubmitDTO &&
      state.softPull.applicationSubmitDTO.airConditioningSystem),
  user: state.auth.user,
});

const mapDispatchToProps = dispatch => ({
  dispatchChangePage: page => dispatch(changePage(page)),
  dispatchResetState: props => dispatch(resetState(props)),
  dispatchResetNewAppState: () => dispatch(resetNewAppState()),
  dispatchChangeSoftPullValue: (key, value) => dispatch(changeSoftPullValue(key, value)),
  dispatchSetFlow: flow => dispatch(setFlow(flow)),
  dispatchSubmitMindfire: params => dispatch(submitMindfire(params)),
});

ScoreError.propTypes = {
  dispatchChangePage: PropTypes.func,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ScoreError),
);
